// extracted by mini-css-extract-plugin
module.exports = {"productList":"Products_productList__8pie9","productListLoading":"Products_productListLoading__FocCn","load":"Products_load__4NE7v"};